import { createFileRoute } from "@tanstack/react-router"
import { ProposalPage } from "@/features/catalogue-review/ProposalPage"

export const Route = createFileRoute("/catalogue-v2/proposals/$proposalId")({
	component: Page,
})

function Page() {
	const { proposalId } = Route.useParams()
	return <ProposalPage proposalId={proposalId} />
}
